import { Component, Pipe, PipeTransform, OnDestroy, Inject, ViewChild } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA} from '@angular/material';

import {SlideshowService} from '../slideshow.service';
import {ApiService} from '../../shared/api.service';

@Pipe({name: 'taxFilter'})
export class TaxFilterPipe implements PipeTransform {
    transform(list, text, taxObj): string {
        if( !text ) {
            return list;
        }
        
        return list.filter(item => {
            return JSON.stringify(taxObj[item]).indexOf(text) !== -1;
        });
    }
}

@Component({
    selector: 'meta-component',
    templateUrl: 'meta.component.html'
})
export class MetaComponent implements OnDestroy {
    publishSubscription;
    user;
    userCanEdit;
    taxonomies = [];
    editTax = false;
    addTermTo = '';
    newTaxonomyName = '';
    newTermName = '';
    loadingTax = false;
    taxError = '';
    taxonomyEditor = '';
    removeTaxClickOnce = false;
    saved = false;
    heartbeatSubscription;

    @ViewChild('addTaxEl') addTaxEl;
    @ViewChild('addTermEl') addTermEl;
    
    constructor(
        private api: ApiService,
        public slideshow: SlideshowService, 
        private dialog: MatDialog
    ) {
        let user = api.getProp('user');
        this.user = user;
        if( user.role != 'writer' ) {
            this.userCanEdit = true;
        }
        this.heartbeatSubscription = this.api.heartbeat.subscribe(() => {
            if( this.editTax ) {
                this.checkLock(false);
            }
        });
    }
    ngAfterViewInit() {
        if( this.slideshow.assignment ) {
            this.setTaxOptions();
        } else {
            this.slideshow.assignmentLoaded.subscribe(data => {
                this.setTaxOptions();
            });
        }        
    }
    setTaxOptions() {
        const taxonomies = Object.keys(this.api['taxonomies']);
        this.taxonomies = taxonomies;
        const assignment = this.slideshow.assignment || {};
        if( assignment.taxonomies ) {
            const slugs = Object.keys(assignment.taxonomies);
            for(var i = 0; i < slugs.length; i++) {
                const tax = slugs[i];
                const termIds = assignment.taxonomies[tax].map(item => item.term_id);
                const options = this.api['taxonomies'][tax].options;
                for(var j = 0; j < options.length; j++) {
                    const option = options[j];
                    if( termIds.indexOf(option.term_id) !== -1 ) {
                        option.checked = true;
                    }
                }
            }
        }
    }
    updateProperties(assignment) {
        this.slideshow.updateMessages();
    }
    updateMetaTitle() {
        this.slideshow.slides[0].metaTitle = this.slideshow.assignment.metaTitle;
    }
    updateMetaDesc() {
        this.slideshow.slides[0].metaDescription = this.slideshow.assignment.metaDescription;
    }
    removeTerm(option, tax) {
        const assignment = this.slideshow.assignment;
        const terms = assignment.taxonomies[tax];
        let i = terms.length;
        while(i--) {
            if( terms[i].term_id == option.term_id ) {
                terms.splice(i, 1);
                if( terms.length == 0 ) {
                    delete assignment.taxonomies[tax];
                }
            }
        }
    }
    addTerm(option, tax) {
        const assignment = this.slideshow.assignment;
        if( !Array.isArray(assignment.taxonomies[tax]) ) {
            assignment.taxonomies[tax] = [];
        }
        assignment.taxonomies[tax].push({
            term_id: option.term_id,
            name: option.name,
            slug: option.slug
        });
    }
    selectOption(option, tax) {
        if( this.slideshow.locked || !this.userCanEdit ) {
            return;
        }
        if( option.checked ) {
            option.checked = false;
            this.removeTerm(option, tax);
        } else {
            option.checked = true;
            this.addTerm(option, tax);
        }
    }
    updateTaxTerm(term) {
        this.taxError = '';
        this.loadingTax = true;
        this.api.doAction('post', 'taxonomy', {
            action: 'update_term',
            term: term
        }).subscribe(
            data => {
                this.triggerSaveMessage();
            },
            err => {
                this.taxError = 'Error updating term';
                throw err;
            }
        ).add(() => {
            this.loadingTax = false;
        });
    }
    maybeRemoveTerm(term, slug) {
        let dialogRef = this.dialog.open(RemoveTaxonomyDialog, {
            data: term.name,
        });
        dialogRef.afterClosed().subscribe(data => {
            if( data === true ) {
                this.removeTaxTerm(term, slug);
            }
        });
    }
    removeTaxTerm(term, slug) {
        this.taxError = '';
        this.loadingTax = true;
        this.api.doAction('post', 'taxonomy', {
            action: 'delete_term',
            term: term
        }).subscribe(
            data => {
                const options = this.api['taxonomies'][slug].options;
                let i = options.length;
                while(i--) {
                    if( options[i].term_id == term.term_id ) {
                        options.splice(i, 1);
                    }
                }
                this.triggerSaveMessage();
            },
            err => {
                this.taxError = 'Error deleting term';
                throw err;
            }
        ).add(() => {
            this.loadingTax = false;
        });
    }
    hasTerm(name, slug) {
        const options = this.api['taxonomies'][slug].options;
        for(var i = 0; i < options.length; i++) {
            if( options[i].name.toLocaleLowerCase() == name.toLocaleLowerCase() ) {
                return true;
            }
        }
        return false;
    }
    addTaxTerm(slug) {
        this.taxError = '';
        if( this.newTermName == '' ) {
            return;
        }
        if( this.hasTerm(this.newTermName, slug) ) {
            this.taxError = 'Term already exists';
            return;
        }
        this.loadingTax = true;
        this.api.doAction('post', 'taxonomy', {
            action: 'add_term',
            taxonomy: slug,
            name: this.newTermName
        }).subscribe(
            data => {
                this.api['taxonomies'][slug].options.push(data);
                this.newTermName = '';
                this.triggerSaveMessage();
            },
            err => {
                this.taxError = 'Error adding new term';
                throw err;
            }
        ).add(() => {
            this.loadingTax = false;
        });
    }
    triggerSaveMessage() {
        this.saved = true;
        setTimeout(() => {
            this.saved = false;
        }, 2000);
    }
    maybeRemoveTax(slug) {
        const name = this.api['taxonomies'][slug].name;
        let dialogRef = this.dialog.open(RemoveTaxonomyDialog, {
            data: name,
        });
        dialogRef.afterClosed().subscribe(data => {
            if( data === true ) {
                this.removeTax(slug);
            }
        });
    }
    updateTax(slug) {
        this.taxError = '';
        this.loadingTax = true;
        this.api.doAction('post', 'taxonomy', {
            action: 'update_taxonomy',
            taxonomy: this.api['taxonomies'][slug]
        }).subscribe(
            data => {
                this.triggerSaveMessage();
            },
            err => {
                this.taxError = 'Error updating taxonomy';
                throw err;
            }
        ).add(() => {
            this.loadingTax = false;
        });
    }
    removeTax(slug) {
        this.taxError = '';
        this.loadingTax = true;
        this.api.doAction('post', 'taxonomy', {
            action: 'delete_taxonomy',
            slug: slug
        }).subscribe(
            data => {
                delete this.api['taxonomies'][slug];
                const slugs = this.taxonomies;
                let i = slugs.length;
                while(i--) {
                    if( slugs[i] == slug ) {
                        slugs.splice(i, 1);
                    }
                }
                this.triggerSaveMessage();
            },
            err => {
                this.taxError = 'Error deleting taxonomy';
                throw err;
            }
        ).add(() => {
            this.loadingTax = false;
        });
    }
    hasTax() {
        const taxonomies = this.api['taxonomies'];
        const slugs = Object.keys(taxonomies);
        const name = this.newTaxonomyName.toLocaleLowerCase();
        for(var i = 0; i < slugs.length; i++) {
            const tax = taxonomies[slugs[i]];
            if( tax.name.toLocaleLowerCase() == name ) {
                return true;
            }
        }
        return false;
    }
    addTax(e) {
        this.taxError = '';
        if( this.newTaxonomyName == '' ) {
            this.taxError = 'Add Taxonomy cannot be blank';
            return;
        }
        if( this.hasTax() ) {
            this.taxError = 'Taxonomy already exists';
            return;
        }
        this.loadingTax = true;
        this.api.doAction('post', 'taxonomy', {
            action: 'add_taxonomy',
            name: this.newTaxonomyName,
            id: this.slideshow.assignment.id
        }).subscribe(
            data => {
                const slug = data.slug;
                this.api['taxonomies'][slug] = data;
                this.taxonomies.push(slug);
                this.newTaxonomyName = '';
                for(var i = 0; i < data.options.length; i++) {
                    const option = data.options[i];
                    if( option.checked ) {
                        this.addTerm(option, slug);
                    }
                }
                this.triggerSaveMessage();
            },
            err => {
                this.taxError = err.error.message;
            }
        ).add(() => {
            this.loadingTax = false;
        });
    }
    takeover() {
        this.taxError = '';
        this.loadingTax = true;
        this.api.doAction('post', 'taxonomy', {
            action: 'set_lock',
            lockAction: 'update'
        }).subscribe().add(() => {
            this.editTax = true;
            this.loadingTax = false;
            this.taxonomyEditor = '';
        });
    }
    cancelTakeover() {
        this.taxError = '';
        this.taxonomyEditor = '';
    }
    setAddTermTo(tax) {
        this.addTermTo = tax;
        setTimeout(() => {
            if( this.addTermEl ) {
                this.addTermEl.nativeElement.focus();
            }
        })
    }
    deleteLock() {
        this.taxError = '';
        this.loadingTax = true;
        this.api.doAction('post', 'taxonomy', {
            action: 'set_lock',
            lockAction: 'delete'
        }).subscribe().add(() => {
            this.editTax = false;
            this.loadingTax = false;
            this.triggerSaveMessage();
        });
    }
    checkLock(takeover) {
        this.api.doAction('post', 'taxonomy', {
            action: 'check_lock'
        }).subscribe(
            data => {
                if( data.locked ) {
                    this.taxonomyEditor = data.taxonomyEditor;
                    this.editTax = false;
                } 
                if( !data.locked && takeover ) {
                    this.takeover();
                }
            },
            err => {
                this.taxError = err.error.message;
            }
        ).add(() => {
            this.loadingTax = false;
        });
    }
    toggleEditTax() {
        if( !this.userCanEdit ) {
            return;
        }
        if( this.editTax ) {
            this.deleteLock();
            return;
        }
        this.taxError = '';
        this.loadingTax = true;
        this.checkLock(true);
    }
    resetTaxonomyOptions() {
        const taxes = this.taxonomies;
        for(var i = 0; i < taxes.length; i++) {
            const tax = taxes[i];
            const options = this.api['taxonomies'][tax].options;
            for(var j = 0; j < options.length; j++) {
                options[j].checked = false;
            }
        }
    }
    ngOnDestroy() {
        this.deleteLock();
        this.resetTaxonomyOptions();
        if( this.publishSubscription ) {
            this.publishSubscription.unsubscribe();
        }
        if( this.heartbeatSubscription ) {
            this.heartbeatSubscription.unsubscribe();
        }
    }
}
@Component({
    selector: 'remove-taxonomy-dialog',
    template: `
        <h2 mat-dialog-title>Are you sure?</h2>
        <mat-dialog-content fxLayout="column" fxLayoutGap="10px">
            <div *ngIf="!confirmed">Are you sure you want to delete {{data}}?</div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-button [mat-dialog-close]="true">Yes</button>
        </mat-dialog-actions>`,
})
export class RemoveTaxonomyDialog {
    confirmed = false;
    notes = '';
    confirm() {
        this.confirmed = true;
    }
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/tabs/meta.component.ts